"use client"

import { useEffect, useState } from "react"
import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ChevronDown } from "@/lib/icons"

interface GoontaiGenreTabsProps {
  /** The chosen genre as the site names it ("" = all). */
  value: string
  onChange: (value: string) => void
}

const ALL = "__all__"

// One dropdown on one row, like Hitomi's and Rule34's. The genres are the site's own list (/api/booru/goontai/genres, about 50), read when the
// strip first shows, not written here; any genre Platform tags hides for this viewer is not in it.
export function GoontaiGenreTabs({ value, onChange }: GoontaiGenreTabsProps) {
  const [genres, setGenres] = useState<string[]>([])

  useEffect(() => {
    let alive = true
    fetch("/api/booru/goontai/genres")
      .then((response) => (response.ok ? response.json() : { genres: [] }))
      .then((data) => alive && Array.isArray(data?.genres) && setGenres(data.genres))
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [])

  return (
    <div className={SOURCE_FILTER_ROW}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={`${sourceFilterPill(value !== "")} inline-flex items-center gap-1`}>
            Genre: {value || "All"}
            <ChevronDown className="h-3 w-3" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="max-h-[60vh] min-w-[10rem] overflow-y-auto">
          <DropdownMenuRadioGroup value={value || ALL} onValueChange={(next) => onChange(next === ALL ? "" : next)}>
            <DropdownMenuRadioItem value={ALL}>All</DropdownMenuRadioItem>
            {genres.map((genre) => (
              <DropdownMenuRadioItem key={genre} value={genre}>
                {genre}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
